import React from 'react';

import { TruncatedValue } from '@pkg/components/Sections/Admin/Users/styles';

import { type LootBoxType } from '@app/client/common/structs/nft/loot-box';

type LootBoxTypesListProps = { lootBoxTypes: LootBoxType[] };

const LootBoxTypesList = ({ lootBoxTypes }: LootBoxTypesListProps) => {
    return (
        <table className="lb-table">
            <tbody>
                <tr key="x1" className="row-header type main">
                    <td>id</td>
                    <td>name</td>
                    <td>description</td>
                    <td> config</td>
                </tr>
                {lootBoxTypes.map((type, i) => {
                    return (
                        <tr key={i} className="type">
                            <td>
                                <TruncatedValue $maxWidth={80} title={type.id}>
                                    {type.id}
                                </TruncatedValue>
                            </td>
                            <td>{type.name}</td>
                            <td>{type.description}</td>
                            <td>
                                <table className="lb-table sub-table">
                                    <tbody>
                                        <tr className="row-header type">
                                            <td>size</td>
                                            <td>min base score</td>
                                            <td>max base score</td>
                                            <td>guarantees</td>
                                            <td>weights</td>
                                        </tr>
                                        <tr className="type">
                                            <td>{type.config.size}</td>
                                            <td>{type.config.min_base_score}</td>
                                            <td>{type.config.max_base_score}</td>
                                            <td>
                                                {type.config.guarantees.length > 0 && (
                                                    <table className="lb-table sub-table">
                                                        <tbody>
                                                            <tr className="row-header type">
                                                                <td>count</td>
                                                                <td>min score</td>
                                                                <td>max score</td>
                                                            </tr>
                                                            {type.config.guarantees.map((g, i) => {
                                                                return (
                                                                    <tr key={i + 'g'} className="type">
                                                                        <td>{g.count}</td>
                                                                        <td>{g.min_score}</td>
                                                                        <td>{g.max_score}</td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                )}
                                            </td>
                                            <td>
                                                {type.config.weights.length > 0 && (
                                                    <table className="lb-table sub-table">
                                                        <tbody>
                                                            <tr className="row-header type">
                                                                <td>min score</td>
                                                                <td>max score</td>
                                                                <td>ipr</td>
                                                            </tr>
                                                            {type.config.weights.map((w, i) => {
                                                                return (
                                                                    <tr key={i + 'w'} className="type">
                                                                        <td>{w.min_score}</td>
                                                                        <td>{w.max_score}</td>
                                                                        <td>{w.ipr}</td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                )}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};

export default LootBoxTypesList;
